import { createRouter, createWebHistory } from 'vue-router'
import processingvV2 from '../views/ProcessingV2.vue'
import NotificationManagementView from '../views/NotificationManagementView'
import DashboardShell from '../views/DashboardShell.vue'
import CommandCenter from '../views/CommandCenter.vue'
import DashboardViewV2 from '../views/DashboardViewV2.vue'


import PostCloseConnect from '../views/PostCloseConnect.vue'
import PostCloseConnectV2 from '../views/PostCloseConnectV2.vue'
import ApplicationsView from '../views/ApplicationsView'
import CondtionCommandView from '../views/ConditionCommand.vue'
import ConditionMain from '../components/conditionCommand/ConditionsDashboardMain.vue'
import Insights from '@/views/Insights.vue'
import LeaderboardView from '@/views/LeaderboardView.vue'
import RepricedLocksDashboard from '@/views/RepricedLocksDashboard.vue'
import RepriceApproval  from '@/views/Repriceapproval.vue'
import HmdaWithdrawalDashboard from '@/views/HmdaWithdrawalDashboard.vue'
import FhaMipPaymentsDashboard from '@/views/FhaMipPaymentsDashboard.vue'
import AiInsuringDashboard from '@/views/AiInsuringDashboard.vue'
import ReverseMortgageView from '@/views/ReverseMortgageView.vue'
import LockExtensionsDashboard from '@/views/LockExtensionsDashboard.vue'
import LockExtensionLanding from '@/views/LockExtensionLanding.vue'
import LoanPriceSheet from '@/views/LoanPriceSheet.vue'
import LockDeskQueue from '@/views/LockDeskQueue.vue'
import RevenueAnalysis from '@/views/RevenueAnalysis.vue'
import LockValidations from '@/views/LockValidations.vue'
import Concessions from '@/views/Concessions.vue'
import ConcessionRequest from '@/views/ConcessionRequest.vue'
import InitialDisclosureDashboard from '@/views/InitialDisclosureDashboard.vue'
import PccdDashboard from '@/views/PccdDashboard.vue'
import DisclosureAuditDashboard from '@/views/DisclosureAuditDashboard.vue'
import InsuringView from '@/views/InsuringView.vue'
import LoRedirect from '@/views/LoRedirect.vue'
import PollyPricerView from '@/views/PollyPricerView.vue'
import DebtConsolidationCalculator from '@/views/DebtConsolidationCalculator.vue'
import PaymentCalculator from '@/views/PaymentCalculator.vue'
import BuydownCalculator from '@/views/BuydownCalculator.vue'
import TurnTimesView from '@/views/TurnTimesView.vue'
import CashOutRefiWizard from '@/views/CashOutRefiWizard.vue'
import ScenarioBuilder from '@/views/ScenarioBuilder.vue'

const routes = [
    {
    path: '/ICD',
    name: 'initialDisclosures',
    component: InitialDisclosureDashboard
  },
  {
    path: '/pccd',
    name: 'pccd',
    component: PccdDashboard
  },
  {
    path: '/disclosure-audit',
    name: 'disclosureAudit',
    component: DisclosureAuditDashboard
  },
  {
    path: '/loan-price-sheet',
    name: 'LoanPriceSheet',
    component: LoanPriceSheet
  },
  {
    // Calculators are standalone arithmetic tools -- no loanId, no API, no saved state. The
    // /calculators/* prefix is deliberate: isPathActive() matches on prefix, so the sidebar
    // group lights up for every calculator added under it without touching navConfig's logic.
    path: '/calculators/debt-consolidation',
    name: 'debtConsolidationCalculator',
    component: DebtConsolidationCalculator
  },
  {
    // Ported from CGS2022's Turn Times page. Ungated, as it was there.
    path: '/turn-times',
    name: 'turnTimes',
    component: TurnTimesView
  },
  {
    path: '/calculators/payment',
    name: 'paymentCalculator',
    component: PaymentCalculator
  },
  {
    // Ported from CGS2022's Buydown Calculator. Ungated, like the other calculators.
    path: '/calculators/buydown',
    name: 'buydownCalculator',
    component: BuydownCalculator
  },
  {
    path: '/calculators/cash-out-refi',
    name: 'cashOutRefiWizard',
    component: CashOutRefiWizard
  },
  {
    path: '/calculators/scenario-builder',
    name: 'scenarioBuilder',
    component: ScenarioBuilder
  },
  {
    // Opened in its own browser tab (sidebar button = Scenario Mode with no loanId, or a
    // pipeline row button = Lock Mode for that loan), so — like concessionRequest — this
    // needs a real URL rather than in-memory state.
    path: '/polly-pricer/:loanId?',
    name: 'pollyPricer',
    component: PollyPricerView,
    props: true
  },
  {
    path: '/lock-extension-request',
    name: 'LockExtensionLanding',
    component: LockExtensionLanding
  },
  {
    path: '/lock-desk-queue',
    name: 'lockDeskQueue',
    component: LockDeskQueue
  },
  {
    path: '/revenue-analysis',
    name: 'revenueAnalysis',
    component: RevenueAnalysis
  },
  {
    path: '/validations',
    name: 'validations',
    component: LockValidations
  },
  {
    path: '/concessions',
    name: 'concessions',
    component: Concessions
  },
  {
    // Opened in its own browser tab from the pipeline, so it needs a real URL rather
    // than in-memory state. No loanId = the manual path, for a loan the pipeline
    // cannot offer.
    path: '/concessions/request/:loanId?',
    name: 'concessionRequest',
    component: ConcessionRequest,
    props: true
  },
  {
    path: '/extensions',
    name: 'extensions',
    query: { id: '' },
    component: LockExtensionsDashboard
  },
  {
    path: '/reprice',
    name: 'reprice',
    query: { id: '' },
    component: RepricedLocksDashboard
  },
   {
    path: '/reprice-approval',
    name: 'repriceApproval',
    component: RepriceApproval
  },
  {
    path: '/processing',
    name: 'processing',
    query: { id: '' },
    component: processingvV2
  },
  {
    path: '/Processingv2',
    name: 'processingv2',
    query: { id: '' },
    component: processingvV2
  },
  {
    path: '/NotificationManagement',
    name: 'notificationManagement',
    component: NotificationManagementView
  },


  {
    path: '/',
    name: 'dashboard',
    component: DashboardShell
  },
  {
    path: '/commandcenter',
    name: 'commandcenter',
    component: CommandCenter
  },
  {
    path: '/dashboardv2',
    name: 'dashboardv2',
    component: DashboardViewV2
  }, 
  {
    path: '/PostCloseConnect',
    name: 'postCloseConnect',
    component: PostCloseConnectV2
  },
  {
    path: '/PostCloseConnectV2',
    name: 'postCloseConnectV2',
    component: PostCloseConnectV2
  },
  {
    path: '/Applications',
    name: 'applications',
    component: ApplicationsView
  },
  {
    path: '/ConditionCommand',
    name: 'condtionCommand',
    component: CondtionCommandView
  },
  {
    path: '/ConditionMain',
    name: 'ConditionMain',
    component: ConditionMain
  },
  ,
  {
    path: '/Insights',
    name: 'Insights',
    component: Insights
  },
  {
    path: '/Leaderboard',
    name: 'Leaderboard',
    component: LeaderboardView
  },
  {
    path: '/hmda-withdrawals',
    name: 'hmdaWithdrawals',
    component: HmdaWithdrawalDashboard
  },
  {
    path: '/fha-mip-payments',
    name: 'fhaMipPayments',
    component: FhaMipPaymentsDashboard
  },
  {
    path: '/loans-funded',
    name: 'loansFunded',
    component: () => import('../views/LoansFundedDashboard.vue')
  },
  {
    path: '/ai-insuring',
    name: 'aiInsuring',
    component: AiInsuringDashboard
  },
  {
    path: '/reverse-mortgage',
    name: 'reverseMortgage',
    component: ReverseMortgageView
  },
  {
    path: '/Insuring',
    name: 'insuring',
    component: InsuringView
  },
  {
  path: '/application-commercial',
  name: 'CommercialLoan',
   component: () => import('../views/CommercialLoanView.vue'),
   meta: { requiresAuth: true }
  },
  {
    path: '/LORedirect',
    name: 'loRedirect',
    component: LoRedirect
  },
  {
    // My Profile — under the "Tools" nav group (was "Me") with My Website.
    path: '/my-profile',
    name: 'myProfile',
    component: () => import('../views/MyProfileView.vue')
  },
  {
    // swiftAnalyze — AI document screenings from GSAI_DocumentPipeline. Admin only: the page shows
    // its not-authorized card to anyone else, and GSWebAPIv2 returns 403 regardless.
    path: '/swift-analyze',
    name: 'swiftAnalyze',
    component: () => import('../views/SwiftAnalyzeDashboard.vue')
  },
 
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router